import * as z from 'zod'

export type UpdateAvailabilityFormData = z.infer<
	typeof updateAvailabilitySchema
>

export type WorkingHours = z.infer<typeof workingHoursSchema>

const baseTimeSlotSchema = z.object({
	startTime: z.string().time(),
	endTime: z.string().time(),
})

export const timeSlotSchema = baseTimeSlotSchema.refine(
	(data) => {
		const startMinutes = timeToMinutes(data.startTime)
		const endMinutes = timeToMinutes(data.endTime)
		return startMinutes < endMinutes
	},
	{
		message: "L'heure de début doit être antérieure à l'heure de fin",
		path: ['startTime'],
	},
)

const timeToMinutes = (time: string) => {
	const [hours, minutes] = time.split(':').map(Number)
	return hours * 60 + minutes
}

export const dateOverrideSchema = z
	.object({
		date: z.string().date(),
		available: z.boolean(),
	})
	.merge(baseTimeSlotSchema)

export const workingHoursSchema = z.object({
	mon: z.array(timeSlotSchema),
	tue: z.array(timeSlotSchema),
	wed: z.array(timeSlotSchema),
	thu: z.array(timeSlotSchema),
	fri: z.array(timeSlotSchema),
	sat: z.array(timeSlotSchema),
	sun: z.array(timeSlotSchema),
})

export const updateAvailabilitySchema = z.object({
	name: z.string().min(1, 'Name is required'),
	description: z.string().optional(),
	timezone: z.string().min(1, 'Timezone is required'),
	workingHours: workingHoursSchema,
	dateOverrides: z.array(dateOverrideSchema).optional(),
	isDefault: z.boolean().optional(),
})
